var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _path5, _path6, _rect4, _path7, _rect5, _path8, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistencePlanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 145,
    viewBox: "0 0 296 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#3880CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7438 66.4247C59.1419 67.1341 58.8458 68.0532 58.9206 68.9806C59.1039 71.5515 61.8732 72.9848 64.1971 72.1428C64.7214 71.9503 65.196 71.6428 65.586 71.2429C65.9761 70.8431 66.2716 70.361 66.4511 69.832C66.6305 69.303 66.6893 68.7406 66.623 68.186C66.5567 67.6313 66.3672 67.0986 66.0682 66.6268C64.6162 64.1906 61.3193 64.5648 59.7438 66.4247Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2345 79.5488C59.2447 79.1855 59.2031 78.8226 59.111 78.4711C58.9101 77.5409 58.7726 76.5982 58.6993 75.6494C58.5983 74.4145 57.2361 68.0827 57.0677 66.0582C57.021 65.4236 56.8095 64.8121 56.454 64.2844C56.1331 63.9312 55.7434 63.6472 55.3089 63.4498C54.0105 62.7653 52.6692 62.1653 51.2935 61.6536C50.242 61.2794 49.0482 60.9276 48.0153 61.3392C47.237 61.6461 46.6719 62.316 46.1442 62.9634C45.3808 63.8964 44.6149 64.827 43.8465 65.755C43.3647 66.2755 42.9727 66.8724 42.6864 67.5214C42.6455 67.6948 42.5604 67.8546 42.4395 67.9854C42.3058 68.0788 42.1493 68.1344 41.9867 68.1463L29.3268 70.1746C28.4463 70.257 27.5919 70.5181 26.8158 70.9417C26.0673 71.417 25.5284 72.3151 25.738 73.1871C25.8642 73.5692 26.0934 73.9091 26.4005 74.1693C26.7075 74.4294 27.0804 74.5998 27.4781 74.6615C28.2752 74.7736 29.0863 74.7355 29.8694 74.5492L42.4657 72.3526C42.8025 72.2964 43.2889 72.3525 43.3039 72.6893C43.3039 72.9775 42.9596 73.116 42.6752 73.1683C38.4839 73.9343 34.2802 74.6228 30.064 75.234C29.2577 75.2995 28.4708 75.5153 27.7438 75.8702C27.044 76.2744 26.4827 77.034 26.565 77.8386C26.6474 78.6432 27.4257 79.3355 28.249 79.5451C29.0888 79.7034 29.952 79.6894 30.7862 79.5039C34.9052 78.8652 39.0216 78.1929 43.1355 77.4869C45.1912 77.1351 47.2445 76.7746 49.2952 76.4054C49.8116 76.3118 54.9534 75.1779 55.0432 75.4361C55.283 76.1672 55.4546 76.9188 55.5559 77.6815C55.5615 77.6945 55.5643 77.7085 55.5643 77.7226C55.5643 77.7368 55.5615 77.7508 55.5559 77.7638C55.543 77.7782 55.5265 77.789 55.5081 77.7949C55.4897 77.8008 55.47 77.8017 55.4511 77.7975C54.901 77.7975 54.3284 77.7975 53.7858 77.8274C53.1497 77.8536 52.4386 78.0706 52.1729 78.6469C51.8773 79.2869 52.3077 80.0727 52.9214 80.4095C53.5704 80.6941 54.282 80.8062 54.9871 80.7351C55.5821 80.7351 56.1808 80.7688 56.7796 80.7613C57.3783 80.7538 58.2391 80.8511 58.7405 80.5031C58.8924 80.3943 59.0163 80.2512 59.1021 80.0853C59.188 79.9194 59.2334 79.7356 59.2345 79.5488V79.5488ZM50.3056 66.5334C49.8438 66.5902 49.3854 66.6714 48.9322 66.7767C48.1613 66.9675 47.4054 67.2856 46.612 67.2594C47.4353 66.3513 48.2499 65.4407 49.0557 64.5276C49.1227 64.4358 49.215 64.3656 49.3214 64.3255C49.432 64.3108 49.5445 64.3263 49.647 64.3704C50.8594 64.7858 51.911 65.4931 53.0149 66.133L50.3056 66.5334Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#3880CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.744 66.4247C155.142 67.1341 154.846 68.0532 154.921 68.9806C155.104 71.5515 157.873 72.9848 160.197 72.1428C160.721 71.9503 161.196 71.6428 161.586 71.2429C161.976 70.8431 162.272 70.361 162.451 69.832C162.631 69.303 162.689 68.7406 162.623 68.186C162.557 67.6313 162.367 67.0986 162.068 66.6268C160.616 64.1906 157.319 64.5648 155.744 66.4247Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.234 79.5488C155.245 79.1855 155.203 78.8226 155.111 78.4711C154.91 77.5409 154.773 76.5982 154.699 75.6494C154.598 74.4145 153.236 68.0827 153.068 66.0582C153.021 65.4236 152.809 64.8121 152.454 64.2844C152.133 63.9312 151.743 63.6472 151.309 63.4498C150.01 62.7653 148.669 62.1653 147.294 61.6536C146.242 61.2794 145.048 60.9276 144.015 61.3392C143.237 61.6461 142.672 62.316 142.144 62.9634C141.381 63.8964 140.615 64.827 139.847 65.755C139.365 66.2755 138.973 66.8724 138.686 67.5214C138.646 67.6948 138.56 67.8546 138.439 67.9854C138.306 68.0788 138.149 68.1344 137.987 68.1463L125.327 70.1746C124.446 70.257 123.592 70.5181 122.816 70.9417C122.067 71.417 121.528 72.3151 121.738 73.1871C121.864 73.5692 122.093 73.9091 122.4 74.1693C122.708 74.4294 123.08 74.5998 123.478 74.6615C124.275 74.7736 125.086 74.7355 125.869 74.5492L138.466 72.3526C138.802 72.2964 139.289 72.3525 139.304 72.6893C139.304 72.9775 138.96 73.116 138.675 73.1683C134.484 73.9343 130.28 74.6228 126.064 75.234C125.258 75.2995 124.471 75.5153 123.744 75.8702C123.044 76.2744 122.483 77.034 122.565 77.8386C122.647 78.6432 123.426 79.3355 124.249 79.5451C125.089 79.7034 125.952 79.6894 126.786 79.5039C130.905 78.8652 135.022 78.1929 139.136 77.4869C141.191 77.1351 143.244 76.7746 145.295 76.4054C145.812 76.3118 150.953 75.1779 151.043 75.4361C151.283 76.1672 151.455 76.9188 151.556 77.6815C151.561 77.6945 151.564 77.7085 151.564 77.7226C151.564 77.7368 151.561 77.7508 151.556 77.7638C151.543 77.7782 151.527 77.789 151.508 77.7949C151.49 77.8008 151.47 77.8017 151.451 77.7975C150.901 77.7975 150.328 77.7975 149.786 77.8274C149.15 77.8536 148.439 78.0706 148.173 78.6469C147.877 79.2869 148.308 80.0727 148.921 80.4095C149.57 80.6941 150.282 80.8062 150.987 80.7351C151.582 80.7351 152.181 80.7688 152.78 80.7613C153.378 80.7538 154.239 80.8511 154.741 80.5031C154.892 80.3943 155.016 80.2512 155.102 80.0853C155.188 79.9194 155.233 79.7356 155.234 79.5488V79.5488ZM146.306 66.5334C145.844 66.5902 145.385 66.6714 144.932 66.7767C144.161 66.9675 143.405 67.2856 142.612 67.2594C143.435 66.3513 144.25 65.4407 145.056 64.5276C145.123 64.4358 145.215 64.3656 145.321 64.3255C145.432 64.3108 145.544 64.3263 145.647 64.3704C146.859 64.7858 147.911 65.4931 149.015 66.133L146.306 66.5334Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 31,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#3880CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.179 65.2809C254.427 66.1676 254.057 67.3166 254.15 68.4758C254.379 71.6894 257.841 73.481 260.746 72.4285C261.401 72.1878 261.994 71.8035 262.482 71.3037C262.969 70.8039 263.339 70.2012 263.563 69.54C263.787 68.8788 263.861 68.1758 263.778 67.4825C263.695 66.7892 263.458 66.1232 263.084 65.5335C261.27 62.4882 257.148 62.956 255.179 65.2809Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.543 81.6865C254.556 81.2324 254.504 80.7788 254.388 80.3393C254.137 79.1766 253.965 77.9982 253.874 76.8123C253.748 75.2686 252.045 67.3539 251.834 64.8232C251.776 64.0299 251.512 63.2657 251.067 62.6059C250.666 62.1644 250.179 61.8095 249.636 61.5628C248.013 60.7072 246.336 59.9572 244.617 59.3175C243.302 58.8497 241.81 58.41 240.519 58.9245C239.546 59.3081 238.84 60.1454 238.18 60.9547C237.226 62.121 236.268 63.2842 235.308 64.4443C234.706 65.0949 234.216 65.841 233.858 66.6522C233.807 66.8689 233.7 67.0687 233.549 67.2322C233.382 67.349 233.186 67.4185 232.983 67.4334L217.158 69.9687C216.058 70.0718 214.99 70.3981 214.019 70.9277C213.084 71.5217 212.41 72.6444 212.672 73.7343C212.83 74.212 213.117 74.6369 213.5 74.9621C213.884 75.2873 214.35 75.5002 214.847 75.5774C215.844 75.7175 216.858 75.6699 217.836 75.437L233.582 72.6912C234.003 72.621 234.611 72.6912 234.63 73.1122C234.63 73.4724 234.199 73.6454 233.844 73.7109C228.605 74.6683 223.35 75.529 218.08 76.293C217.072 76.3749 216.088 76.6446 215.18 77.0883C214.305 77.5935 213.603 78.5431 213.706 79.5488C213.809 80.5545 214.782 81.4199 215.811 81.6818C216.861 81.8798 217.94 81.8623 218.983 81.6304C224.131 80.832 229.277 79.9916 234.419 79.1091C236.989 78.6693 239.555 78.2187 242.119 77.7572C242.764 77.6402 249.192 76.2229 249.304 76.5456C249.603 77.4594 249.818 78.399 249.945 79.3523C249.952 79.3686 249.955 79.3861 249.955 79.4038C249.955 79.4214 249.952 79.439 249.945 79.4552C249.929 79.4733 249.908 79.4867 249.885 79.4941C249.862 79.5015 249.837 79.5026 249.814 79.4973C249.126 79.4973 248.41 79.4973 247.732 79.5347C246.937 79.5675 246.048 79.8388 245.716 80.5592C245.346 81.3591 245.884 82.3414 246.651 82.7624C247.463 83.1181 248.352 83.2582 249.234 83.1694C249.977 83.1694 250.726 83.2115 251.474 83.2021C252.223 83.1927 253.299 83.3144 253.925 82.8793C254.115 82.7434 254.27 82.5644 254.377 82.3571C254.485 82.1498 254.541 81.92 254.543 81.6865V81.6865ZM243.382 65.4173C242.805 65.4883 242.231 65.5898 241.665 65.7213C240.701 65.9599 239.756 66.3575 238.765 66.3247C239.794 65.1896 240.812 64.0514 241.819 62.91C241.903 62.7953 242.019 62.7075 242.151 62.6574C242.29 62.639 242.43 62.6584 242.558 62.7135C244.074 63.2327 245.388 64.1168 246.768 64.9167L243.382 65.4173Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.5 101L170.5 105L177.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 101L74.5 105L81.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 141,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 26,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 130.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 15.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 117.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 37.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.5 12L204.5 24.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M267.5 7L261 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M244 129L247.5 143",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistencePlanking);
export default __webpack_public_path__ + "static/media/persistence-planking.54848da52acb447b538a404f67e6dd76.svg";
export { ForwardRef as ReactComponent };